import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, CircularProgress, Divider, Grid, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TodayIcon from '@mui/icons-material/Today';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import Groups2Icon from '@mui/icons-material/Groups2';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import axios from 'axios';
import { getCookie } from '../utils/cookies';
import { getopcinesMenu } from '../services/apis'
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import { Fichar } from '../global/fichaje/Fichar';
import ConstructionIcon from '@mui/icons-material/Construction';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import ClearIcon from '@mui/icons-material/Clear';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

//mapa de iconos
const iconMapping = {
    TodayIcon: <TodayIcon />,
    FolderSpecialIcon: <FolderSpecialIcon />,
    Groups2Icon: <Groups2Icon />,
    AdminPanelSettingsIcon: <AdminPanelSettingsIcon />,
    QuickreplyIcon: <QuickreplyIcon />,
    Fichar: <Fichar />,
    ConstructionIcon: <ConstructionIcon />,
    AccessAlarmIcon: <AccessAlarmIcon />,
    ShoppingCartIcon: <ShoppingCartIcon />,

};

export const MenuLateral = ({ setOpenDrawer, openDrawer }) => {
    // Global
    const navigate = useNavigate();

    // Estados auxiliares
    const [loaded, setLoaded] = useState(false);
    // Estados útiles
    const [opciones, setOpciones] = useState([]);

    // Cargar opciones menú principal
    const cargarOpciones = async () => {
        try {
            const response = await getopcinesMenu();
            // console.log("aa", response.data)
            setOpciones(response.data)
            setLoaded(true);
        } catch (error) {
            console.error("Error al cargar opciones del menu:", error);
            localStorage.clear();
            navigate("/login");
        }
    };

    useEffect(() => {
        cargarOpciones();
    }, []);

    return (
        <div className='menu-lateral fade-in-2 header'>
            {!loaded && (<CircularProgress />)}
            {loaded && (

                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="center"
                    xs={12}
                    sx={{ minHeight: '100vh' }}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={11}
                        sx={{ my: 1 }}
                    >
                        <Typography variant='h6'>
                            MENÚ  PRINCIPAL
                        </Typography>
                        <IconButton color='primary' size='medium' onClick={() => setOpenDrawer(false)}>
                            <ClearIcon sx={{ mt: -0.2, mr: 0.5, color: 'gray', fontSize: 30 }} />
                        </IconButton>
                    </Grid>
                    {/* <Fichar></Fichar> */}
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={11}
                        gap={1}
                    >
                        {opciones
                            .filter((opcion) => opcion.tipo === 1)
                            .map((opcion) => (
                                <>
                                    {iconMapping[opcion.icon]}
                                </>
                            ))}
                        {opciones
                            .filter((opcion) => opcion.tipo === 0)
                            .map((opcion) => (
                                <Grid container direction={'column'} xs={12} onClick={() => navigate(opcion.url)} style={{ cursor: 'pointer' }}>
                                    <Grid container direction={'row'} justifyContent={'start'} alignItems={'center'} xs={12}>
                                        <IconButton color='primary'>
                                            {iconMapping[opcion.icon]}
                                        </IconButton>
                                        <Typography variant="p" component="div">
                                            {opcion.nombre.toUpperCase()}
                                        </Typography>
                                    </Grid>

                                    <Divider />

                                </Grid>
                            ))}

                    </Grid>

                </Grid>
            )}
        </div>
    );
};
